/**
 * @generated SignedSource<<f6de3ee3e2e04c97ca99155ca8f2c271>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type progressBar_projectVersions_VersionProgress$data = {
  readonly done: {
    readonly totalCount: number;
  };
  readonly inProgress: {
    readonly totalCount: number;
  };
  readonly toDo: {
    readonly totalCount: number;
  };
  readonly " $fragmentType": "progressBar_projectVersions_VersionProgress";
};
export type progressBar_projectVersions_VersionProgress$key = {
  readonly " $data"?: progressBar_projectVersions_VersionProgress$data;
  readonly " $fragmentSpreads": FragmentRefs<"progressBar_projectVersions_VersionProgress">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "totalCount"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "progressBar_projectVersions_VersionProgress",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": "done",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": "DONE"
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "done.totalCount"
          }
        ],
        "storageKey": "issues(filter:\"DONE\")"
      },
      "action": "THROW",
      "path": "done"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "inProgress",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": "IN_PROGRESS"
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "inProgress.totalCount"
          }
        ],
        "storageKey": "issues(filter:\"IN_PROGRESS\")"
      },
      "action": "THROW",
      "path": "inProgress"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "toDo",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": "TODO"
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "toDo.totalCount"
          }
        ],
        "storageKey": "issues(filter:\"TODO\")"
      },
      "action": "THROW",
      "path": "toDo"
    }
  ],
  "type": "JiraVersion"
};
})();

(node as any).hash = "728b280b2216bb0f2cdb74b3d92d96fb";

export default node;
